export default "__VITE_ASSET__0f678947__"